/**
 * Accessibility patch for the Frenzy search/filter widget.
 *
 * The widget is served from Frenzy's CDN, so its markup can't be corrected
 * at the source. This observer repairs the rendered DOM:
 * - filter-drawer footer pills (SHOW n RESULTS / CLEAR ALL) are plain divs
 *   with click handlers — expose them as keyboard-operable buttons;
 * - suggestion links wrap the matched term in a highlight span that drops
 *   out of the accessible name — mirror the full text into aria-label;
 * - the "view all results" link can render icon-only — give it a name.
 */
(function () {
  function patch(root) {
    root.querySelectorAll('.frenzy_filter_widget_footer_button:not([data-a11y-patched])').forEach(function (pill) {
      pill.dataset.a11yPatched = '1';
      pill.setAttribute('role', 'button');
      pill.setAttribute('tabindex', '0');
      pill.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          pill.click();
        }
      });
    });

    root.querySelectorAll('.frenzy_sw_nl_item a:not([aria-label]), .frenzy_sw_blog_item a:not([aria-label]), .frenzy_sw_collection_suggestions_list_item a:not([aria-label])').forEach(function (link) {
      var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) {
        link.setAttribute('aria-label', text);
      }
    });

    root.querySelectorAll('a.frenzy_sw_view_all_link:not([aria-label])').forEach(function (link) {
      var text = (link.textContent || '').replace(/\s+/g, ' ').trim();
      link.setAttribute('aria-label', text || 'Show all search results');
    });
  }

  function init() {
    patch(document);
    var observer = new MutationObserver(function () {
      patch(document);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
